import { enums } from "../api/genericData";

let enumValues;
if (typeof window !== "undefined" && !enumValues) {
  const ssrRawJson = document.getElementById("__JSS_STATICDATA__");
  // SSR rendering viewbag is visible, then use the viewbag to fill the enumValue
  // For connected mode we use the AJAX call to fill the enumValue
  if (ssrRawJson) {
    const __JSS_STATICDATA__ = JSON.parse(ssrRawJson.innerHTML);
    if (__JSS_STATICDATA__ && __JSS_STATICDATA__.enums) {
      enumValues = __JSS_STATICDATA__.enums;
    } else {
      getEnumValues((response) => {
        enumValues = response;
      });
    }
  }
}

function getEnumValues(setEnums) {
  if (!enumValues) {
    executeEnums(setEnums);
  }
}

async function executeEnums(setEnums) {
  try {
    const messages = await enums();
    setEnums(messages);
  } catch (e) {
    console.error(`Failed to load messages: ${e}`);
  }
}

function transformEnums(name) {
  return () => {
    if (enumValues) {
      // Clone enum options, allows for transformation without reference
      return JSON.parse(JSON.stringify(enumValues[name]));
    }
    return [];
  };
}

export function storeEnumValues(content) {
  if (Boolean(content)) {
    enumValues = content;
  }
}

export const dlpInsuranceTypes = transformEnums("InsuranceType");

export const dupInsuranceProductTypes = transformEnums("DupInsuranceProductType");

export const dupPaymentPeriod = transformEnums("PayPeriod");

export const paymentTerms = transformEnums("PaymentTerm");

export const yesOrNo = transformEnums("YesOrNo");

export const salutations = transformEnums("GenderSalutation");

export const useOfName = transformEnums("UseOfName");
